<template>
  <div class="d-flex justify-content-end">
    <ul class="pagination">
      <li class="page-item" :class="{ 'disabled': data?.page === 1 }">
        <a class="page-link btn mx-1" @click="changePage(1)">{{ $t('paginations.start') }}</a>
      </li>
      <li class="page-item" v-for="(item, index) in data?.pageList" :key="index" :class="{ 'active': item == data?.page }">
        <a class="page-link btn mx-1" @click="changePage(item)">{{ item }}</a>
      </li>
      <li class="page-item" :class="{ 'disabled': data?.page === data?.maxPage }">
        <a class="page-link btn mx-1" @click="changePage(data?.maxPage)">{{ $t('paginations.end') }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'paginationPage',
  props: {
    data: { type: Object, required: true }
  },
  emits: ["update:page"],
  methods: {
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.data?.maxPage) {
        this.$emit("update:page", newPage);
      }
    },
  },
};
</script>

<style scoped>
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  color: white;
}

.pagination .page-link {
  cursor: pointer;
}
</style>